/**
 * ArchiveType
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import {
  GROUPTYPES_GENERAL,
  GROUPTYPES_CLASS,
  GROUPTYPES_SCHOOL,
  GROUPTYPES_FOUNDATION,
} from 'containers/User/constants.js';
import ColorBlock from 'components/media/ColorBlock/index.js';
import { format } from 'utils/date-fns/index.js';
import { Card } from 'react-bootstrap';
import SearchInfo from 'components/interaction/Search/SearchInfo.jsx';
import messages from './messages.js';
import ArchiveControl from './ArchiveControl.jsx';
import ChildGroups from './ChildGroups.jsx';
import AdminList from '../AdminList.jsx';
import useSearchableList from '../useSearchableList.js';
import AdminHeader from '../AdminHeader.jsx';

const typeLabels = {
  [GROUPTYPES_SCHOOL]: messages.school,
  [GROUPTYPES_CLASS]: messages.class,
  [GROUPTYPES_GENERAL]: messages.general1,
  [GROUPTYPES_FOUNDATION]: messages.foundation,
};

const GroupName = styled.span`
  color: ${(p) => p.theme.gray};
`;

const TypeLabel = styled.span`
  font-size: small;
  line-height: 1.25;
`;

function ArchiveType(props) {
  const { intro, search } = props;
  const url = 'sa/groups/archive';
  const selector = 'sa/groups/archive';
  const header = (
    <thead>
      <tr>
        <th className="narrow">&nbsp;</th>
        <th className="name"><FormattedMessage {...messages.name} /></th>
        <th><FormattedMessage {...messages.members} /></th>
        <th className="sub-groups">&nbsp;</th>
        <th><FormattedMessage {...messages.messages} /></th>
        <th><FormattedMessage {...messages.archivedOn} /></th>
        <th><FormattedMessage {...messages.deleteOn} /></th>
        <th className="d-print-none narrow">&nbsp;</th>
      </tr>
    </thead>
  );
  function renderRow(item) {
    return (
      <tr key={item.id}>
        <td className="narrow">
          <ColorBlock color={item.theme.themeColor} />
        </td>
        <td className="name name-column low-padding">
          <GroupName>{item.name}</GroupName>
          <TypeLabel><FormattedMessage {...typeLabels[item.groupType]} /></TypeLabel>
        </td>
        <td><span className="num">{item.memberCount}</span></td>
        <td className="sub-groups"><ChildGroups group={item} /></td>
        <td><span className="num">{item.postCount}</span></td>
        <td><span>{format(item.archivedOn, 'PP', 'dt')}</span></td>
        <td><span>{format(item.deleteOn, 'PP', 'dt')}</span></td>
        <td className="d-print-none low-padding narrow">
          <ArchiveControl group={item} />
        </td>
      </tr>
    );
  }

  const { items, list } = useSearchableList({ search, url, selector, version: 2, clientSearch: false });

  return (
    <Card>
      <AdminHeader
        title={messages.archive}
        intro={intro}
        count={items.totalCount}
      />
      <SearchInfo className="mx-4" search={search} />
      <AdminList
        resetKey={search}
        items={items}
        list={list}
        emptyMessage={messages.noGroups}
        header={header}
        renderRow={renderRow}
      />
    </Card>
  );
}

ArchiveType.propTypes = {
  intro: PropTypes.object,
  search: PropTypes.string,
};

export default ArchiveType;
